"use strict";

/* global app, socket, bootbox */

(function() {
	/*
		This file shows how client-side javascript can be included via a plugin.
		If you check `plugin.json`, you'll see that this file is listed under "scripts".
		That array tells NodeBB which files to bundle into the minified javascript
		that is served to the end user.

		Some events you can elect to listen for:

		$(document).ready();			Fired when the DOM is ready
		$(window).on('action:ajaxify.end', function(data) { ... });			"data" contains "url"
	*/

	console.log('nodebb-plugin-connect-edit-timeout: loaded');

	require(['components', 'composer', 'composer/drafts', 'taskbar'], function(components, composer, drafts, taskbar) {

		/*$(window).on('action:post.tools.load', function(event, data) {
			console.log(event);
			console.log(data);
			var postEl = $(this).parents('[data-pid]');
			var pid = postEl.attr('data-pid');
			console.log(pid);
		});*/

		$(window).on('action:composer.post.edit', function(event, params) {
			socket.emit('plugins.connectedittimeout.checkEditable', {pid: params.pid}, function(err, errMessage) {
				if (err) {
					setTimeout(function() { composerClose() }, 500);
					app.alert(errMessage);
				}
			});
		});

		//COPYFROM: composer.js - START
		function removeComposerHistory() {
			var env = utils.findBootstrapEnvironment();
			if (env === 'xs' || env ==='sm') {
				history.back();
			}
		}

		function stopNotifyTyping(postData) {
			if (!parseInt(postData.tid, 10)) {
				return;
			}
			socket.emit('plugins.composer.stopNotifyTyping', {
				tid: postData.tid,
				uid: app.user.uid
			});
		}

		function stopNotifyInterval(postData) {
			if (postData.notifyTypingIntervalId) {
				clearInterval(postData.notifyTypingIntervalId);
				postData.notifyTypingIntervalId = 0;
			}
		}

		function discard(post_uuid) {
			if (composer.posts[post_uuid]) {
				$('#cmp-uuid-' + post_uuid).remove();
				drafts.removeDraft(composer.posts[post_uuid].save_id);
				stopNotifyInterval(composer.posts[post_uuid]);
				stopNotifyTyping(composer.posts[post_uuid]);

				delete composer.posts[post_uuid];
				composer.active = undefined;
				taskbar.discard('composer', post_uuid);
				$('body').css({'margin-bottom': 0});
				$('[data-action="post"]').removeAttr('disabled');
				$('html').removeClass('composing mobile');
			}
		}
		//COPYFROM: composer.js - END

		function composerClose() {
			removeComposerHistory();
			if(composer.active) {
				discard(composer.active);
			}
		}

		socket.on('connectedittimeout:composerclose', function(params) {
			app.alert(params);
			composerClose();
		});

		function getData(button, data) {
			return button.parents('[data-pid]').attr(data);
		}

		$('[component="topic"]').on('show.bs.dropdown', '.moderator-tools', function() {
			console.log("RR1");
			var $this = $(this);
			var dropdownMenu = $this.find('.dropdown-menu');
			if (dropdownMenu.html()) {
				return;
			}

			var postEl = $this.parents('[data-pid]');
			var pid = postEl.attr('data-pid');
			//var index = parseInt(postEl.attr('data-index'), 10);

			postEl.on('click', '[component="post/history"]', function() {
				socket.emit('plugins.connectedittimeout.getHistory', {pid: pid}, function(err, connectData) {
					app.parseAndTranslate('modals/connect-edit-timeout-history', connectData, function(ConnectTpl) {
						if (err) {
							app.alertError('Error loading data, try again');
							//TO DO
						} else {
							var box = bootbox.dialog(
								{
									message:ConnectTpl,
									title: 'Edit History',
									show: false
								}
							);
							box.on("shown.bs.modal", function() {
								$('.timeago').timeago();
							});

							box.modal('show');
						}
					});
				});
			});
			//return false;
		});

		$('[component="topic"]').on('shown.bs.dropdown', '.moderator-tools', function() {
			var $this = $(this);
			var postEl = $this.parents('[data-pid]');
			var pid = postEl.attr('data-pid');
			$(window).on('action:post.tools.load', function(event, data) {
				socket.emit('plugins.connectedittimeout.checkInTime', {tid: ajaxify.data.tid, pid: pid}, function(err, checkInTime) {
					if(!err && !checkInTime) {
						console.log(postEl.html());
						console.log(postEl.find('[component="post/edit"]').html());
						postEl.find('[component="post/edit"]').html(postEl.find('[component="post/edit"]').html().replace("Modifica", "Proponi Modifica"));
					}
				});
			});
		});
	});
}());
